module.exports = __webpack_public_path__ + "img/big.c17f2628.jpg";